// Finished window previews only. Never accepts the uploaded source, fitting data or Shopify payloads.
(function(root) {
  'use strict';
  if (root.NoDrillPhotoStore) return;
  function create(options = {}) {
    const name = options.name || 'ndr-cart-pictures-v1';
    const maxRecords = options.maxRecords ?? 50;
    const maxBytes = options.maxBytes ?? 20 * 1024 * 1024;
    const now = options.now || Date.now;
    const timeoutMs = options.timeoutMs ?? 2500;
    const lifetime = 30 * 86400000;
    const validId = id => typeof id === 'string' && id.length > 0 && id.length <= 160;
    const validBlob = blob => blob instanceof Blob && ['image/jpeg', 'image/png'].includes(blob.type) && blob.size > 0;
    function run(action, id, blob) {
      return new Promise(resolve => {
        let db, transaction, settled = false;
        const fail = reason => finish({ok:false, reason});
        const finish = result => {
          if (settled) return;
          settled = true;
          clearTimeout(timer);
          if (!result.ok && transaction) { try { transaction.abort(); } catch (_) { /* Already settled. */ } }
          if (db) db.close();
          resolve(result);
        };
        const timer = setTimeout(() => fail('timeout'), timeoutMs);
        try {
          const indexedDB = Object.hasOwn(options, 'indexedDB') ? options.indexedDB : root.indexedDB;
          if (!indexedDB) return fail('unavailable');
          const request = indexedDB.open(name, 1);
          request.onblocked = () => fail('blocked');
          request.onerror = () => fail(request.error?.name || 'unavailable');
          request.onupgradeneeded = () => {
            if (settled) { request.transaction.abort(); return; }
            if (!request.result.objectStoreNames.contains('pictures')) request.result.createObjectStore('pictures', {keyPath:'id'});
          };
          request.onsuccess = () => {
            db = request.result;
            if (settled) { db.close(); return; }
            db.onversionchange = () => db.close();
            try {
              // One transaction makes limit checks, pruning and writes atomic across tabs.
              transaction = db.transaction('pictures', 'readwrite');
              const store = transaction.objectStore('pictures');
              let result = {ok:true};
              transaction.oncomplete = () => finish(result);
              transaction.onabort = transaction.onerror = () => fail(transaction.error?.name || 'storage-error');
              const all = store.getAll();
              all.onsuccess = () => {
                try {
                  const time = now();
                  const live = all.result.filter(record => {
                    const keep = validId(record.id) && validBlob(record.blob) && Number.isFinite(record.savedAt)
                      && record.savedAt > time - lifetime;
                    if (!keep) store.delete(record.id);
                    return keep;
                  });
                  if (action === 'load') result.blob = live.find(record => record.id === id)?.blob || null;
                  if (action === 'remove') store.delete(id);
                  if (action === 'save') {
                    const others = live.filter(record => record.id !== id);
                    const bytes = others.reduce((sum, record) => sum + record.blob.size, 0) + blob.size;
                    if (others.length >= maxRecords || bytes > maxBytes) result = {ok:false, reason:'limit'};
                    else store.put({id, blob, savedAt:time});
                  }
                } catch (_) { fail('storage-error'); }
              };
            } catch (_) { fail('unavailable'); }
          };
        } catch (error) { fail(error?.name || 'unavailable'); }
      });
    }
    return {
      save: (id, blob) => validId(id) && validBlob(blob) ? run('save', id, blob) : Promise.resolve({ok:false, reason:'invalid'}),
      load: id => validId(id) ? run('load', id) : Promise.resolve({ok:true, blob:null}),
      remove: id => validId(id) ? run('remove', id) : Promise.resolve({ok:false, reason:'invalid'}),
      prune: () => run('prune'),
    };
  }
  root.NoDrillPhotoStore = {...create(), create};
  // Expiry is enforced on the next visit/read, not by a clock while the browser is closed.
  root.NoDrillPhotoStore.prune();
})(globalThis);
